import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useMyRestaurants } from '../hooks/useMyRestaurants';
import { useRole } from '../hooks/useRole';

export function RequireRestaurant({ children }: { children: ReactNode }) {
  const { restaurants, loading } = useMyRestaurants();
  const { isMaster, loading: roleLoading } = useRole();
  const { t } = useTranslation();

  if (loading || roleLoading) return <div className="center-note">{t('common.loading')}</div>;
  // Master acessa o painel mesmo sem restaurante próprio (usa a área Master).
  if (restaurants.length === 0 && !isMaster) return <Navigate to="/onboarding" replace />;
  return <>{children}</>;
}
